module.exports = __webpack_public_path__ + "static/patterns-distances-36be01522db6f7560911a905965b3098.png";